import React, { useState, useEffect } from 'react';

import { parseDate } from '../utils/parseDate';
import { getStepFromStatus, getStatusText, isValidEmail } from '../utils/Miscellaneous';
import usePostNotificationsAlerts from '../hooks/usePostNotificationsAlerts';
import '../styles/logging.css';

// Helper function to validate multiple email addresses
const areValidEmails = (emailString) => {
    // Split by commas or semicolons and trim each email
    const emails = emailString.split(/[;,]/).map(email => email.trim());
    return emails.every(email => isValidEmail(email));
};

const EmailingComponent = ({ transactions }) => {
    const [emailSubject, setEmailSubject] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [error, setError] = useState('');
    const [showResponse, setShowResponse] = useState(false);
    const [responseText, setResponseText] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);
    const { postNotificationsAlerts, alertResponse, postError } = usePostNotificationsAlerts("EMAIL");

    const handleUserDetailChange = (e) => {
        setEmailSubject(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmailAddress(e.target.value);
    };

    const handleSubmit = async () => {
        setError('');
        setIsErrorResponse(false);

        if (!emailSubject) {
            setError('Subject cannot be empty');
            return;
        }

        if (!areValidEmails(emailAddress)) {
            setError('Please enter valid email addresses');
            return;
        }

        if (transactions.length === 0) {
            setError('No transactions available');
            return;
        }

        const transactionDetails = transactions.map((transaction) => (
            `${parseDate(transaction?.DateTime)} - Boomi ${getStepFromStatus(transaction?.boomiStatus)} EDI ${transaction?.documentType} ${transaction?.documentReferenceType} ${transaction?.documentIdentifier} ${getStatusText(transaction?.boomiStatus) === 'sent' ? `to ${transaction?.receiverName}` : `from ${transaction?.senderName}`} ${transaction?.boomiStatus === 'Received-Error' ? 'with errors' : ''}`
        )).join('\n');

        const emailDetailRequest = {
            userinput: emailSubject,
            users_email_id: emailAddress,
            doctype: transactions[0]?.documentReferenceType,
            Customer: transactions[0]?.senderName,
            documentidentifier: transactions[0]?.documentIdentifier,
            MessagegroupID: transactions[0]?.messageGroupId,
            transactiondetails: transactionDetails
        };

        console.log('emailDetailRequest:', emailDetailRequest);

        if (window.confirm('Are you sure you want to send the email?')) {
            try {
                await postNotificationsAlerts(emailDetailRequest);
                setShowResponse(true);
            } catch (error) {
                console.error('Error posting notification alert:', error);
                setError('Failed to email the transaction details');
            }
        }
    };

    const responseMessage = (response) => {
        const baseMessage = response?.message || '';
        const additionalDetails = response?.additionalDetails ? ` ${response.additionalDetails}` : '';
        return `${baseMessage}${additionalDetails}`.trim();
    };

    useEffect(() => {
        if (alertResponse) {
            setResponseText(responseMessage(alertResponse));
            setIsErrorResponse(alertResponse.success === "false");
        }
    }, [alertResponse]);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(responseText);
        setShowResponse(false);
    };

    return (
        <div className='transaction-logs'>
            <input
                name='emailSubject'
                value={emailSubject}
                onChange={handleUserDetailChange}
                placeholder="Enter email subject"
            />
            <input
                name='emailAddress'
                value={emailAddress}
                onChange={handleEmailChange}
                placeholder='Enter comma-separated or semicolon-separated email addresses'
            />
            <button onClick={handleSubmit} className='email-button'>Send Email</button>
            {error && <p className="error-message">{error}</p>}
            {postError && <p className="error-message">Error: {postError.message}</p>}
            {alertResponse && showResponse && (
                <div className="response-container">
                    <textarea
                        className={`response-text ${isErrorResponse ? 'error-response' : ''}`}
                        readOnly
                        value={responseText}
                    />
                    <button onClick={copyToClipboard} className='copy-button'>Copy to Clipboard</button>
                    <button onClick={() => setShowResponse(false)} className='close-button'>Close</button>
                </div>
            )}
        </div>
    );
};

export default EmailingComponent;
